<div class="fc-signup-sent">
    <div class="fc-signup-sent-inner">
        <div class="fc-signup-sent-image">
            <img src="assets/img/fc_signup_thank_you.svg" />
        </div>
        <div class="fc-signup-sent-text">
            <div class="fc-signup-sent-text-header">
                {{ 'THANK_YOU' | translate }}
            </div>
            <div class="fc-signup-sent-text-title">
                {{ text.title | translate }}
            </div>
            <div class="fc-signup-sent-text-description">
                {{ text.description | translate }}
            </div>

            <div class="fc-signup-sent-text-contact-description">
                {{ 'SIGNUP.FORM.REQUEST_SENT.CONTACT_INFO' | translate }}
            </div>
            <div class="fc-signup-sent-contact-email">{{ supportEmail }}</div>
        </div>
    </div>
</div>
